import { Component, OnInit, ViewChild, ElementRef, EventEmitter, Output, Input } from '@angular/core';
import * as Highcharts from 'highcharts';
import * as _ from 'underscore';
import * as jQuery from 'jquery';

@Component({
	selector: 'app-social-demograph',
	templateUrl: './social-demograph.component.html',
	styleUrls: ['./social-demograph.component.css']
})
export class SocialDemographComponent implements OnInit {
	@ViewChild('graphArea', { static: true }) graphElement: ElementRef;

	@Input() c: any;
	@Input() graphData: any;
	@Input() name: any;
	@Input() legendDisabled;
	@Input() svgWidth;
	@Input() svgHeight;
	@Input() ticksRotation;
	@Input() chartType;
	@Input() selectedLegend;
	@Input() legendData;
	@Output() legendSelected = new EventEmitter<any>();
	@Output() mouseOverChart = new EventEmitter<any>();
	@Output() mouseOutChart = new EventEmitter<any>();

	private defaultCount = 5;
	private stepCount;
	private maxPoints = 50;
	private dataLength = 0;
	private leftExtreme = 0;
	private rightExtreme = 0;

	constructor() {}

	ngOnInit() {
		this.legendDisabled = this.legendDisabled === true ? true : false;
	}

	ngOnChanges(changes) {
		if (!_.isEmpty(this.graphData)) {
			this.stepCount = this.calculateStepCount();
			this.dataLength = this.graphData.categories.length - 1;
			this.drawGraph();
		}
	}

	selectLegendItem(legendItem) {
		this.legendSelected.emit(legendItem);
	}
	drawGraph() {
		let self = this;
		Highcharts.chart(
			this.graphElement.nativeElement,
			{
				chart: {
					type: 'area',
					margin: [20, 40, 40, 40],
					height: this.svgHeight || 400
				},
				title: {
					text: ''
				},
				legend: {
					layout: 'vertical',
					align: 'left',
					verticalAlign: 'top',
					floating: true,
					backgroundColor: '#FFFFFF',
					symbolPadding: 0,
					symbolWidth: 0,
					symbolRadius: 0,
					itemStyle: {
						cursor: 'default'
					}
				},
				xAxis: {
					categories: this.graphData.categories
				},
				yAxis: {
					gridLineWidth: 0,
					title: {
						text: ''
					},
					visible: false,
					labels: {
						formatter: function () {
							return String(this.value);
						}
					}
				},
				tooltip: {
					formatter: function () {
						return (
							'<b>' +
							this.series.name.split('|')[0] +
							' ' +
							this.x +
							'<br/>' +
							this.y.toLocaleString('en') +
							' ' +
							self.selectedLegend +
							'</b>'
						);
					}
				},
				plotOptions: {
					area: {
						fillOpacity: 0.5,
						fillColor: self.graphData.color
					},
					series: {
						marker: {
							enabled: false
						}
					}
				},
				credits: {
					enabled: false
				},
				series: [this.graphData.series]
			},
			function (chart) {
				var series = chart.series;
				jQuery(series).each(function (i, serie:any) {
					if (serie.legendSymbol) serie.legendSymbol.destroy();
					if (serie.legendLine) serie.legendLine.destroy();
				});
			}
		);
	}
	protected calculateStepCount() {
		if (this.maxPoints <= this.defaultCount) {
			return 1;
		}
		if (this.ticksRotation === '0') {
			return 10;
		}
		return Math.ceil(this.maxPoints / (this.defaultCount * 2));
	}

	private mouseOverEvent(eventObj) {
		const index = eventObj.target.series.index;
		this.mouseOverChart.emit({ index: index, toggle: true });
	}
}
